// src/components/booking/loadBookingDealerships.ts
// Carga de sucursales para la agenda, con las columnas `timezone` y
// `appointment_comms`.
//
// Vive aparte de bookingShared.ts porque eso son piezas PURAS (sin red) y esto
// consulta la base; y aparte de cada componente porque BookingModal y
// AgendarForm hacían exactamente la misma consulta y el reintento tiene que ser
// el mismo en los dos.
//
// `dealerships.timezone` es de la migración de B2 y `appointment_comms` de la
// de comunicaciones de agenda (20260831120000). Mientras alguna no esté
// aplicada, PostgREST rechaza la consulta ENTERA con 42703 / PGRST204 y la
// agenda se quedaría sin sucursales — o sea, en blanco. Por eso el reintento
// en cascada, quitando una columna opcional por vez: el sitio sigue
// funcionando, `businessTimezone` cae al mapa por `clients.country` (mismo
// valor) y sin `appointment_comms` se asume "sin avisos" (= la web manda el
// correo, como siempre). Es lo que permite desplegar este cambio ANTES que las
// migraciones, sin ventana incompatible.

import { supabase } from '@/lib/supabase';
import type { DealershipItem } from './bookingShared';

const missingColumn = (e: { code?: string; message?: string } | null) =>
  !!e && (
    e.code === '42703' || e.code === 'PGRST204' ||
    /timezone|appointment_comms/i.test(e.message || '')
  );

/** De más a menos columnas; se baja un escalón por cada columna que falte. */
const COLUMNAS = [
  'id,address,timezone,appointment_comms',
  'id,address,timezone',
  'id,address',
] as const;

export async function loadBookingDealerships(clientId: number): Promise<DealershipItem[]> {
  const pedir = (cols: string) =>
    supabase.from('dealerships').select(cols).eq('client_id', clientId);

  let { data, error } = await pedir(COLUMNAS[0]);
  for (let i = 1; i < COLUMNAS.length && error && missingColumn(error); i++) {
    ({ data, error } = await pedir(COLUMNAS[i]));
  }
  if (error) {
    console.error('No se pudieron cargar las sucursales de la agenda:', error);
    return [];
  }

  const list = ((data as unknown as DealershipItem[]) || []).slice();
  list.sort((a, b) => (a.address || '').localeCompare(b.address || ''));
  return list;
}

export default loadBookingDealerships;
